// Stored answers are zero-based indexes matching the survey's option order.
const TOXIC_BEHAVIOR_RISK_BY_OPTION_INDEX = [
  0,   // Never
  25,  // Rarely
  50,  // Sometimes
  75,  // Often
  100, // Very frequently
]

export function toxicBehaviorRiskScoreFromAnswer(answer: any): number | null {
  if (answer === undefined || answer === null || answer === '') return null

  const answerIndex = Number(answer)
  if (!Number.isFinite(answerIndex) || !Number.isInteger(answerIndex)) return null

  const riskScore = TOXIC_BEHAVIOR_RISK_BY_OPTION_INDEX[answerIndex]
  return riskScore === undefined ? null : riskScore
}
